// Translation file for authentication pages

export const auth = {
  login: {
    title: "Bejelentkezés",
    subtitle: "Lépj be a fiókodba és folytasd a munkát",
    heroTitle: "Bejelentkezés",
    heroSubtitle: "Folytasd az utad velünk",
    email: "E-mail cím",
    password: "Jelszó",
    loginButton: "Bejelentkezés",
    loginButtonLoading: "Bejelentkezés...",
    googleLogin: "Belépés Google fiókkal",
    googleLoginAlt: "Bejelentkezés Google-lel",
    or: "vagy",
    forgotPassword: "Elfelejtett jelszó?",
    noAccount: "Még nincs fiókod?",
    register: "Regisztráció",
    backToLanding: "← Vissza a főoldalra",
    noBespirePage: "Nincs még saját Bespire oldalad?",
    startNow: "Kezdd el most",
    errorTitle: "Hibás bejelentkezési adatok",
    errorDescription: "Kérjük ellenőrizd az e-mail címet és jelszót, majd próbáld újra.",
    googleErrorTitle: "Hiba történt a Google bejelentkezés során",
    googleErrorDescription: "Kérjük próbáld újra később."
  },
  register: {
    title: "Hozd létre a fiókodat",
    subtitle: "Kezdd el az utad velünk még ma",
    username: "Felhasználónév",
    fullName: "Teljes neved",
    email: "E-mail cím",
    phone: "Telefonszám",
    registerButton: "Ingyenes regisztráció",
    googleRegister: "Belépés Google fiókkal",
    or: "vagy",
    termsText: "A regisztrációval elfogadod az",
    termsLink: "Általános Szerződési Feltételeket",
    and: "és az",
    privacyLink: "Adatvédelmi Szabályzatot",
    hasAccount: "Már van fiókod?",
    login: "Bejelentkezés"
  },
  languages: {
    hungarian: "Magyar",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    spanish: "Español",
    dutch: "Nederlands",
    polish: "Polski"
  }
};